import { concat } from "@ember/helper";
import DButton from "discourse/ui-kit/d-button";
import DModal from "discourse/ui-kit/d-modal";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";
import FrlClock from "./frl-clock";

const FrlDebugModal = <template>
  <DModal
    @closeModal={{@closeModal}}
    @title={{i18n
      (concat "flexible_rate_limits.debug_modal.title." @model.limitType)
    }}
    id="frl-debug-modal"
  >
    <:body>
      <table class="table">
        <tbody>
          <tr>
            <td>{{i18n "flexible_rate_limits.debug_modal.table.senior"}}</td>
            <td>
              {{#if @model.newUser}}
                {{dIcon "xmark" class="new-user"}}
              {{else}}
                {{dIcon "check" class="senior"}}
              {{/if}}
            </td>
          </tr>
          <tr>
            <td>{{i18n "flexible_rate_limits.debug_modal.table.setting"}}</td>
            <td>{{@model.data.setting}}</td>
          </tr>
          <tr>
            <td>{{i18n "flexible_rate_limits.debug_modal.table.limit"}}</td>
            <td>{{@model.data.limit}}</td>
          </tr>
          <tr>
            <td>{{i18n "flexible_rate_limits.debug_modal.table.remaining"}}</td>
            <td>{{@model.data.remaining}}</td>
          </tr>
        </tbody>
      </table>
    </:body>

    <:footer>
      <div class="frl-flex">
        <DButton
          @action={{@closeModal}}
          @icon="xmark"
          @label="flexible_rate_limits.debug_modal.close"
          class="btn-large btn-primary"
        />

        <div class="frl-flex-fill frl-flex-center">
          {{#if @model.showCounter}}
            <FrlClock @wait={{@model.wait}} />
          {{/if}}
        </div>
      </div>
    </:footer>
  </DModal>
</template>;

export default FrlDebugModal;
